import { Card, Table } from 'react-bootstrap'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Loading from '../../../templates/UI/Loading/Loading'

const PaymentDetails = ({ data, dataLoaded }) => {
    return (
        <Card className="mb-4">
            <Card.Header>
                <div>Payment Details</div>
            </Card.Header>
            <Table striped bordered>
                <thead>
                    <tr>
                        <th>Affiliate ID</th>
                        <th>Affiliate</th>
                        <th>Status</th>
                        <th>Contact</th>
                    </tr>
                </thead>
                {dataLoaded ? (
                    <>
                        {data.success && data.info.matchingPaymentDetails.length > 0 ? (
                            <tbody>
                                {data.info.matchingPaymentDetails.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.affiliate_id}</td>
                                            <td>
                                                <Affiliate aid={item.affiliate_id} name={item.name} status={item.aff_status_value} priority={item.aff_priority_value} />
                                            </td>
                                            <td>{item.aff_status}</td>
                                            <td>{item.contact}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan="4">No data found</td>
                                </tr>
                            </tbody>
                        )}
                    </>
                ) : (
                    <Loading />
                )}
            </Table>
        </Card>
    )
}

export default PaymentDetails
